import { Storage } from '@ionic/storage';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Platform } from '@ionic/angular';
import { timer } from 'rxjs';
import { ConfigProvider } from '../config/config';
import { AppDetectorProvider } from '../detector/detector';
import { LidProvider } from '../lid-provider/lid-provider';
import { RequestProvider } from '../request/request';
import { StorageProvider } from '../storage-service/storage-service';
import { DarkMode, ThemeMode } from '../dark-mode/dark-mode';
import { Subscription } from 'rxjs';
import { Cache } from 'src/assets/data/cache-key/cache-key';

declare var adsbygoogle: Array<any>;
declare var admob;
declare var cordova:any;

@Injectable({providedIn:'root'})
export class AdsProvider {
  mob;

  /**
   * detects if it's allowed to call hide/show methods. If isLocked = true then it means that some servies called hide or show method and wants nobody to overwrite it. 
   */
  isLocked: boolean = false;
  banner
  // darkmode
  isMode
  backgroundColor
  toDarkSub:Subscription;
  hasShown:boolean = false;

  constructor(
    public http: HttpClient,
    private config: ConfigProvider,
    private platform: Platform,
    private lid: LidProvider,
    private storage: StorageProvider,
    private appDetector: AppDetectorProvider,
    private request: RequestProvider) { 
      if(platform.is('ios')){
        this.platform.ready().then(async() => {
          // await admob.start();
          this.show();
        })
      } else if (platform.is('android')){
        this.platform.ready().then(async() => {
          this.show();
        })
      }
    }
    updateAdMobBannerBackground() {
        this.isMode = JSON.parse(localStorage.getItem('darkMode') || `"${ThemeMode.LightMode}"`) as ThemeMode;
        if (this.isMode=='darkMode') {
          this.backgroundColor = '#373737'
        } else if(this.isMode=='lightMode'){
           this.backgroundColor = 'white'
        }
        admob.BannerAd.config({
          backgroundColor: this.backgroundColor,
          marginBottom:this.platform.is('ios')?10:60
        });
        //test
        // this.banner.show({ adUnitId: 'ca-app-pub-3940256099942544/6300978111'});
        //prod
        this.banner.show({adUnitId:'ca-app-pub-3372584184973915/6010960498'})
    }

  async initAds() {

    console.log('google ads 0.1')
    let adsDisabled = (await this.config.config).ads.disabled;
    console.log("JSON.parse(localStorage.getItem('premium'))",JSON.parse(localStorage.getItem('premium')))
    if (JSON.parse(localStorage.getItem('premium'))) return;

    const config = await this.config.config;

    if (config.ads.type === 'googleBrowser') {
      this.googleAdsBrowser();
    } else if (config.ads.type === 'google') {
      this.initPhone();
    } else if (config.ads.type === 'sponsor') {
      this.sponsorAds();
    }
  }
  initPhone() {
    console.log('this.hasShown initPhone', this.hasShown)
    // if(!this.hasShown){
      this.show()
  }

  /**
   * 
   * @param full detects whether to leave the small white bar at the bottom or extend the parent component to 100%.
   * the small bar at the bottom is needed for iOS line. 
   */
  async hide(full: boolean = false) {
    if (typeof admob === "undefined") {
      console.warn("Admob is not defined...");
      return;
    }
    console.log('hide this.isLocked', this.isLocked)
    if (this.isLocked) return;
    console.log('hide this.hasShown', this.hasShown)
      if(this.hasShown){
        this.hasShown = false;
        // await this.banner.hide({
          // test id
          // adUnitId: 'ca-app-pub-3940256099942544/6300978111'
          //  adUnitId:'ca-app-pub-3372584184973915/6010960498'
        // });
        if(await this.banner.isLoaded()) await this.banner.hide()
        this.banner = null
    }
  }

  show() {
    if (typeof admob === "undefined") {
      console.warn("Admob is not defined...");
      return;
    }
    console.log('this.hasShown show', this.hasShown)
    
    if (!JSON.parse(localStorage.getItem('premium')) && !this.isLocked) {
      this.platform.ready().then(async () => {
        if (!(await this.config.config).platform.browser) {
          if(this.platform.is('ios') && !this.hasShown){
            this.platform.ready().then(async() => {
              this.banner = new admob.BannerAd({
                // test id
                // adUnitId: 'ca-app-pub-3940256099942544/6300978111',
                //prod
                adUnitId:'ca-app-pub-3372584184973915/6010960498',
                size:"SMART_BANNER",
              })
              admob.BannerAd.config({
                marginBottom: -20
              })
              try{
                await this.banner.load(); 
              }catch(err){
                console.log('banner.load', err)
                setTimeout(() => {
                  console.log('Retrying to load banner ad...');
                  this.show();
                }, 2000);
              }
                const isLoaded = await this.banner.isLoaded();
                if(isLoaded){
                  console.log('IOS Admob isLoaded', isLoaded)
                  //test
                  // await this.banner.show({ adUnitId: 'ca-app-pub-3940256099942544/6300978111'});
                  //prod
                  await this.banner.show({adUnitId:'ca-app-pub-3372584184973915/6010960498'})
                }
              this.updateAdMobBannerBackground();
              this.hasShown = true;
            }) 
          }
          // && !this.hasShown 
          else if(this.platform.is('android') && !this.hasShown ){
            console.log('show adndroid')
            this.platform.ready().then(async() => {
              this.banner = new admob.BannerAd({
                // test id
                // adUnitId: 'ca-app-pub-3940256099942544/6300978111',
                //prod
                adUnitId:'ca-app-pub-3372584184973915/6010960498',
                size:"SMART_BANNER",
                offset: 55
              })
              admob.BannerAd.config({ //doesnt work in android
                marginBottom: 60,
                marginTop:0
              })
              try{
                await this.banner.load();
                console.log('this.banner.isLoaded()', this.banner)
                if (await this.banner.isLoaded()) {
                  try{
                    await this.banner.show();
                  }catch(err){
                    console.log('show err', err)
                    setTimeout(() => {
                      console.log('Retrying to load banner ad...');
                      this.show();
                    }, 3000);
                  }
                // }
                  this.updateAdMobBannerBackground();
                  this.hasShown = true;

                }
              }catch(err){
                console.log('err in load', err)
                setTimeout(() => {
                  console.log('Retrying to load banner ad...');
                  this.show();
                }, 3000);
              }
            })
          }
          }
      });
      // let item = document.getElementsByClassName('ad-type-native');
      // if (item.length > 0) {
      //   item.item(0).setAttribute('style', "height: calc(100% - 60px) !important");
      // }

      
    }
  }

  googleAdsBrowser() { }

  sponsorAds() {
    let repeat = 0;

    timer(0, 9900).subscribe(async () => {
      let element = document.getElementById('sponsor-ads');
      if (element) {
        element.setAttribute('class', 'sponsor-' + (repeat + 1));
      }
      repeat = (repeat + 1) % (await this.config.config).ads.numberOfAds;
    });
  }

  getSponsorAds(): Promise<any> {
    return  new Promise<any>(async (resolve, reject) => { 
      const config = await this.config.config;
      if(this.appDetector.isHannoverApp()){
        let sponsors = (await this.config.config).ads.sponsors;
        resolve(sponsors);
      }
      this.lid.getLid().then(lid => {
        if (!navigator.onLine) this.storage.getSaved(Cache.SPONSOR_IMAGES + lid).then(r => resolve(r));
        else {
          this.request.getApiSimple<any>(`user/${lid}/sponsors/bylid`, {}, 2000, "backoffice").then(result => {
            this.storage.saveData(result, Cache.SPONSOR_IMAGES + lid);
            if(result && result.length==0){
              let sponsors = config.ads.sponsors;
              resolve(sponsors);
            }else{
              resolve(result);
            }
          });
        }
      });
    });
  }
}
